import {
  useMutation,
  UseMutationResult,
  UseMutationOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import type {
  ResponseDto,
  VerifyRecoveryCodeDto,
  VerifyRecoveryCodeResponseDto,
} from "@mimber/schema"

export const useVerifyRecoveryCode = (
  options?: UseMutationOptions<
    ResponseDto<VerifyRecoveryCodeResponseDto>,
    Error,
    VerifyRecoveryCodeDto
  >
): UseMutationResult<
  ResponseDto<VerifyRecoveryCodeResponseDto>,
  Error,
  VerifyRecoveryCodeDto
> => {
  guardAppUsage("mimber-organization", "useVerifyRecoveryCode")

  const { server } = useServerContext()

  return useMutation({
    ...options,
    mutationFn: async (data: VerifyRecoveryCodeDto) => {
      const response = await server.post<
        ResponseDto<VerifyRecoveryCodeResponseDto>
      >("account/mfa/recovery-codes/verify", data)
      return response.data
    },
    onSuccess: (response, variables, onMutateResult, context) => {
      options?.onSuccess?.(response, variables, onMutateResult, context)
    },
  })
}
